(function () {
    'use strict';

    function WZCompanyScheduleV2Controller($scope, $timeout, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {

        var $ctrl = this;
        loadPage();

        function initSchedule() {
            $timeout(function () {
                $ctrl.schedule = {};
                $ctrl.schedule.weeklyScheduleInfo = {};
                $ctrl.schedule.weeklyScheduleInfo.timePeriod = {};
                var startTime = new Date();
                startTime.setHours(8, 0, 0, 0);
                var endTime = new Date();
                endTime.setHours(17, 0, 0, 0);
                $ctrl.schedule.weeklyScheduleInfo.timePeriod.startTime = startTime;
                $ctrl.schedule.weeklyScheduleInfo.timePeriod.endTime = endTime;
                $ctrl.schedule.weeklyScheduleInfo.weekdays = [];
                angular.forEach(DAYS_VALUES, function (val) {
                    var weekday = {};
                    if (val != 'FRIDAY') {
                        weekday.weekday = val;
                        //weekday.timePeriod = $ctrl.schedule.weeklyScheduleInfo.timePeriod;
                        $ctrl.schedule.weeklyScheduleInfo.weekdays.push(weekday);
                    }
                });
            }, 500);


        }

        function loadAll() {
            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('company');
            translatePartialLoader = translate.refresh();
            initSchedule();
            //

            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }

        $scope.$watch('CompanyScheduleform.$valid', function (isValid) {
            $ctrl.isFormValid(isValid);
        })


    }

    var wzfCompanyScheduleV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/wizard-forms-v2/company-schedule-v2/wizard-form.company-schedule-v2.html',
        controller: WZCompanyScheduleV2Controller,
        bindings:
            {
                schedule: '=?',
                isFormValid: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('wzfCompanyScheduleV2', wzfCompanyScheduleV2)

    WZCompanyScheduleV2Controller.$inject = ['$scope', '$timeout', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

